import {InputProps, MenuItem, TextField, TextFieldProps} from '@mui/material';

import {AMS_SENTRO_TYPES} from '../../constants/node';

export const SentroTypeSelect: React.FC<TextFieldProps> = (props) => {
  const types = AMS_SENTRO_TYPES;

  const handleChange: InputProps['onChange'] = (event: any) => {
    const value = event.target.value !== 'all' ? event.target.value : undefined;
    props.onChange?.(value);
  };

  return props.disabled ? (
    <TextField
      {...props}
      value={types.find((i) => i.key === props.value)?.name ?? ''}
    />
  ) : (
    <TextField
      {...props}
      label={props.label ?? 'Node Type'}
      value={props.value ?? ''}
      select
      onChange={handleChange}
    >
      {types.map((i) => (
        <MenuItem key={i.key} value={i.key}>
          {i.name}
        </MenuItem>
      ))}
    </TextField>
  );
};
